(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const tabButtons = document.querySelectorAll(".faq-tab-btn");
  const tabContents = document.querySelectorAll(".faq-tab-content");

  if(tabButtons.length > 0) {
    tabButtons.forEach(btn => {
      btn.addEventListener("click", function() {
        let tabIndex = this.dataset.tab;
        tabButtons.forEach(b => b.classList.remove("active"));
        tabContents.forEach(c => c.classList.remove("active"));
        this.classList.add("active");
        const targetContent = document.querySelector(`.faq-tab-content[data-tab="${tabIndex}"]`);
        if(targetContent) { targetContent.classList.add("active"); }
      });
    });
  }

  document.querySelectorAll(".faq-accordion-header").forEach(header => {
    header.addEventListener("click", function() {
      this.classList.toggle("active");
      let body = this.nextElementSibling;
      body.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Tabs
  const tabButtons = document.querySelectorAll(".faq-tab-btn");
  const tabContents = document.querySelectorAll(".faq-tab-content");

  tabButtons.forEach(btn => {
    btn.addEventListener("click", function() {
      let tabIndex = this.dataset.tab;

      tabButtons.forEach(b => b.classList.remove("active"));
      tabContents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      document.querySelector(`.faq-tab-content[data-tab="${tabIndex}"]`).classList.add("active");
    });
  });

  // Accordions
  document.querySelectorAll(".faq-accordion-header").forEach(header => {
    header.addEventListener("click", function() {
      this.classList.toggle("active");
      let body = this.nextElementSibling;
      body.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
